import { DataTableService } from './../../../../shared/data-table/data-table.service';
import { PageOptions } from './../../../../shared/data-table/data-table.interface';
import { Component, OnInit, ViewChild } from '@angular/core';

import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { ReasonCodeMaintenanceApiService } from '../../../../../modules/api/reason-code-maintenance-api.service';
import { AddReasonCodeModalService } from '../reason-code-maintenance-modal/add-reason-code/add-reason-code-modal.service';

import { LazyLoadEvent } from 'primeng/api/primeng-api';
import { TprecmService } from '../../tprecm.service';
import { ColumnDef } from 'src/app/shared/data-table/data-table.interface';
import { DataTableValidators } from 'src/app/shared/data-table/validators';
import { ToastrService } from 'ngx-toastr';
import { finalize, filter } from 'rxjs/operators';

@Component({
   templateUrl: './reason-code-maintenance-modal.template.html',
   styleUrls: ['../../tprecm.style.scss']
})
export class ReasonCodeMaintenanceModalComponent implements OnInit {

   total = 0;
   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('id');

   selectedReasonCode;
   loading = false;
   reasonCodes = [];

   columns: ColumnDef[] = [
      {
         field: 'reasonCode', name: 'Reason Code', width: '6em',
         validators: DataTableValidators.maxLength(10, (message: string) => this.toastr.error(message))
      },
      {
         field: 'area', name: 'Area', width: '6em',
         validators: DataTableValidators.maxLength(20, (message: string) => this.toastr.error(message))
      },
      {
         field: 'description', name: 'Description', width: '15em',
         validators: DataTableValidators.maxLength(60, (message: string) => this.toastr.error(message))
      },
      { field: 'designLateFinish', name: 'Design Late Finish?', type: 'checkbox', width: '4em', tooltip: 'Design Late Finish' },
      { field: 'constLateFinish', name: 'Const Late Finish?', type: 'checkbox', width: '4em', tooltip: 'Construction Late Finish' },
      {
         field: 'definitions', name: 'Definitions', width: '20em',
         validators: DataTableValidators.maxLength(255, (message: string) => this.toastr.error(message))
      },
      { field: 'active', name: 'Active?', type: 'checkbox', width: '4em', tooltip: 'Check box if reason code is active.' },
   ];

   constructor(
      private readonly toastr: ToastrService,
      private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
      private readonly reasonCodeMaintenanceApiService: ReasonCodeMaintenanceApiService,
      private readonly addReasonCodeModalService: AddReasonCodeModalService,
      private readonly dataTableService: DataTableService
   ) { }

   ngOnInit() { }

   updateSelectedReasonCode(dataItem) {
      this.selectedReasonCode = dataItem;
   }

   updateReasonCode(dataItem) {
      this.reasonCodeMaintenanceApiService.saveReasonCode(dataItem.data)
         .subscribe(response =>
            Object.assign(
               this.reasonCodes.find(code => code.id === response.id),
               response
            ),
            () => this.loadReasonCodes());
   }

   loadReasonCodes() {
      this.loading = true;

      this.reasonCodeMaintenanceApiService.getReasonCodes(this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe(
            response => {
               this.total = response.totalCount;
               this.reasonCodes = response.data;
            }
         );
   }

   onLazyLoad(event: LazyLoadEvent) {
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadReasonCodes();
   }

   onAddReasonCodeClick() {
      const dialogRef = this.addReasonCodeModalService.showModal();

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(reasonCode => {
            this.pageOptions.sort = 'id';
            this.pageOptions.order = 'desc';
            this.reasonCodes.pop();
            this.reasonCodes.unshift(reasonCode);
         });
   }

   removeHandler() {
      if (!this.selectedReasonCode) {
         this.toastr.error('Please select a reason code to delete');
         return;
      }

      this.cgpConfirmationDialogService.showConfirmationDialog({
         title: 'TPRECM',
         message: `Are you sure you want to delete '${this.selectedReasonCode.reasonCode}'`,
         alert: 'danger',
         onYesClick: () => {
            this.loading = true;
            this.reasonCodeMaintenanceApiService.deleteReasonCode(this.selectedReasonCode.id)
               .pipe(finalize(() => this.loading = false))
               .subscribe(() => {
                  this.loadReasonCodes();
                  this.selectedReasonCode = null;
               });

            this.cgpConfirmationDialogService.closeConfirmationDialog();
         },
         onNoClick: () => this.cgpConfirmationDialogService.closeConfirmationDialog()

      });
   }
}
